import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { AppContextualMenu as AppContextualMenuNext } from "./next/AppContextualMenu/AppContextualMenu";
import type { AppContextualMenuProps } from "./types"; // Adjust the path as needed
import { AppContextualMenuCurrent } from "./AppContextualMenu";
import { useV9MenuEnabled } from "./hooks/useNextComponentsEnabled";

declare let __Delay_FluentV8__: boolean;

const V8AppContextualMenuCurrent =
  typeof __Delay_FluentV8__ === "undefined" || !__Delay_FluentV8__
    ? AppContextualMenuCurrent
    : React.lazy(() =>
        import(/*webpackChunkName: "commonV8"*/ "./AppContextualMenu").then(
          (module) => ({ default: module.AppContextualMenuCurrent })
        )
      );

export * from "./AppContextualMenu";
export * from "./next/AppMenuItem";
export * from "./types";
export * from "./hooks/useNextComponentsEnabled";

export type { AppContextMenuProps as AppContextualMenuPropsNext } from "./next/AppContextualMenu/AppContextualMenu.types";

export const AppContextualMenu = React.forwardRef<
  HTMLDivElement,
  AppContextualMenuProps
>((props, ref) => {
  const isNextMenuEnabled = props.isV9ContextMenuEnabled;
  const isNextFloatieEnabled = props.isV9FloatieEnabled;
  const isV9MenuEnabled = useV9MenuEnabled();
  // For scenarios where a floatie is attached to CM, we will use the V9 CM only if the floatie is also rendered in V9.
  const canUseNextMenu = props.attachedFloatie
    ? isNextFloatieEnabled && isNextMenuEnabled
    : isNextMenuEnabled;

  const useLegacyMenu =
    props.useLegacyContextMenu === undefined
      ? true
      : props.useLegacyContextMenu;

  return ((canUseNextMenu && !useLegacyMenu) || isV9MenuEnabled) &&
    !props.isSearchExecuting ? (
    <AppContextualMenuNext {...props} ref={ref} />
  ) : (
    <React.Suspense fallback={<></>}>
      <V8AppContextualMenuCurrent {...props} ref={ref} />
    </React.Suspense>
  );
});
